import { Injectable } from '@angular/core';
import { LOCAL_STORAGE_KEYS } from '../models/constants';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private keysToExclude: string[] = [
    LOCAL_STORAGE_KEYS.HOURLY_RATE_ARRAY,
    LOCAL_STORAGE_KEYS.FLIGHT_TIME_ARRAY,
    LOCAL_STORAGE_KEYS.LAYOVER_TIME_ARRAY,
  ];

  clear(): void {
    const keys = Object.keys(localStorage);
    for (const key of keys) {
      if (!this.keysToExclude.includes(key)) {
        localStorage.removeItem(key);
      }
    }
  }

  setItem(key: string, value: string) {
    localStorage.setItem(key, value);
  }
  removeItem(key: string) {
    localStorage.removeItem(key);
  }
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }
}
